import { Grid, MenuItem, Typography } from '@material-ui/core';
import MROTextField from 'components/form_components/TextField';
import YesNoField from 'components/form_components/YesNoField';
import QuantityCounter from 'components/quantity_counter';
import React, { useEffect, useState } from 'react'
import useQuoteStyles from '../utils/QuoteStyles';
import useGetBaseDetails from '../Hooks/useGetBaseDetails';

export default function WorkScopeSection(props) {


    const {
        errors,
        setErrors, resetErrorsHandler,
        disabled,
        access,
        quotation,
        handlePopup,
        loading,
        action,
        tatQuantity,
        setTatquantity
    } = props;
    const classes = useQuoteStyles()
    const [workshopBase, setWorkshopBase] = useState(null);
    const [workStatus, setWorkStatus] = useState("")
    const baseStation = useGetBaseDetails()

    const [aogUpdate, setAogUpdate] = useState(null);



    const handleAogUpdate = (value) => {
        if (value) {
            setAogUpdate(value);
        }
        handlePopup();
    };
    useEffect(() => {
        if (action === "Unlock") {
            if (quotation !== null) {

                setWorkshopBase(quotation?.base_station_id);
                setAogUpdate(
                    quotation?.aog_status === true
                        ? "yes"
                        : quotation?.aog_status === false
                            ? "no"
                            : ""
                );

                setTatquantity(quotation?.tat_days);


                setWorkStatus(quotation?.work_status)

            }



        }
    }, [quotation]);
    return (
        <React.Fragment>
            <Grid style={{ marginTop: "4px" }}>
                <Typography color="primary" variant="body1">Workscope</Typography>

            </Grid>

            <Grid
                style={{ marginBottom: "1px", width: "100%" }}
                container
                spacing={3}
                alignItems={"center"}
                justify={"flex-start"}
            >
                <Grid className={classes.purchaseGrid} item xs={3}>
                    <MROTextField
                        name={"base_station_id"}
                        label={"Workshop Base *"}
                        disabled={!props.permission.write}
                        InputProps={{
                            className: disabled && classes.disableField,
                        }}
                        // required
                        select
                        placeholder="Select"
                        defaultValue="Select"
                        InputLabelProps={{ shrink: true }}
                        error={errors.base_station_id}
                        value={workshopBase}
                        onChange={(e) => {
                            resetErrorsHandler(e.target.name);
                            setWorkshopBase(e.target.value);
                            handlePopup();
                        }}
                    >
                        <MenuItem value={"Select"}>Select</MenuItem>
                        {baseStation?.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.station}
                            </MenuItem>
                        ))}
                    </MROTextField>
                </Grid>
                <Grid className={classes.purchaseGrid} item xs={3}>
                    <MROTextField
                        name={"work_status"}
                        label={"Status / Work *"}
                        placeholder={"Select"}
                        value={workStatus}
                        select
                        requird
                        InputProps={{
                            className: disabled && classes.disableField,
                        }}
                        // value={fieldsData.status_work}
                        InputLabelProps={{ shrink: true }}
                        error={errors.work_status}
                        onChange={(e) => {
                            resetErrorsHandler(e.target.name);
                            setWorkStatus(e.target.value);
                            handlePopup();
                        }}
                    >
                        <MenuItem value={"Select"}>Select</MenuItem>
                        <MenuItem value={"Inspected / Tested"}>Inspected / Tested</MenuItem>
                        <MenuItem value={"Repaired"}>Repaired</MenuItem>
                        <MenuItem value={'Overhauled'}>Overhauled</MenuItem>
                        <MenuItem value={'Modified'}>Modified</MenuItem>
                        <MenuItem value={"New"}>New</MenuItem>
                        <MenuItem value={"Prototype"}>Prototype</MenuItem>
                        <MenuItem value={"Customer Instruction"}>Customer Instruction</MenuItem>
                    </MROTextField>
                </Grid>
                <Grid className={classes.purchaseGrid} item xs={3}>
                    <QuantityCounter
                        name={"tat_days"}
                        label={"Estimated TAT-Days*"}
                        // required
                        disabled={disabled || !props.permission.write}
                        placeholder={"Turn Around Time"}
                        InputLabelProps={{ shrink: true, fontSize: "10px" }}
                        InputProps={{
                            classes: {
                                input: classes.inputEstimate,
                            },
                        }}
                        autoFocus={errors["tat_days"]}
                        error={errors["tat_days"]}
                        helperText={
                            errors["tat_days"] &&
                            (errors["quantity_is_zero"]
                                ? "QTY Required Must Be Greater Than 0"
                                : `Please enter Estimated TAT - Days`)
                        }
                        setError={() =>
                            setErrors((prevState) => ({
                                ...prevState,
                                tat_days: false,
                            }))
                        }
                        qty={tatQuantity}
                        setQty={setTatquantity}
                    />
                </Grid>
                <Grid item xs={3}
                    style={{ background: "transparent" }}
                    className={disabled || access.read ? classes.disableField : null}
                >
                    <YesNoField
                        disabled={disabled || !props.permission.write}
                        label="AOG? *"
                        name="aog_status"
                        handleToggle={handleAogUpdate}
                        value={aogUpdate}
                        error={errors.aog_status}
                        setError={() => resetErrorsHandler("aog_status")}
                    />
                </Grid>

            </Grid>


        </React.Fragment>
    )
}
